import styled from '@emotion/styled';

import type { TableColumnWidth } from '~/ui/core/table/Table';
import {
    TableContainer as BaseTableContainer,
    TableBody,
    TableCell,
    TableErrorMessage,
    TableExpandableRow,
    TableExpandButton,
    TableGrid,
    TableHeader,
    TableHeaderCell,
    TableLoadingSpinner,
    TableNameCell,
    TableNameCellContent,
    TableTreeLine,
} from '~/ui/core/table/Table';

const COLUMN_IDS = ['name', 'type', 'status', 'reviewer', 'published', 'roles', 'levels', 'actions'] as const;
type ColumnId = (typeof COLUMN_IDS)[number];

const DEFAULT_COLUMN_WIDTH: TableColumnWidth = '80px';
const COLUMN_WIDTHS: Readonly<Record<ColumnId, TableColumnWidth>> = {
    actions: '112px',
    levels: '100px',
    name: 'minmax(400px, auto)',
    published: '200px',
    reviewer: '170px',
    roles: '100px',
    status: '140px',
    type: '100px',
};

const isColumnId = (columnId: string): columnId is ColumnId => columnId in COLUMN_WIDTHS;

export const getColumnWidth = (columnId: string): TableColumnWidth =>
    isColumnId(columnId) ? COLUMN_WIDTHS[columnId] : DEFAULT_COLUMN_WIDTH;

export const DEFAULT_GRID_COLUMN_WIDTHS: ReadonlyArray<TableColumnWidth> = COLUMN_IDS.map(
    (columnId) => COLUMN_WIDTHS[columnId],
);

export const TableContainer = styled(BaseTableContainer)(({ theme }) => ({
    flex: 1,
    marginRight: theme.spacing.s,
}));

export const Grid = styled(TableGrid)({
    gridTemplateRows: 'auto 1fr',
    maxHeight: '100%',
});

export const GridHeader = styled(TableHeader)(({ theme }) => ({
    padding: theme.spacing.s,
}));

export const GridHeaderCell = TableHeaderCell;

export const GridBody = TableBody;

export const GridRow = styled(TableExpandableRow)({
    marginTop: 0,
});

export const GridCell = styled(TableCell)<{ readonly isLastRow?: boolean }>({});

export const GridLine = TableTreeLine;

export const ExpandButton = TableExpandButton;

export const NameCell = TableNameCell;

export const NameCellContent = TableNameCellContent;

export const LoadingSpinner = TableLoadingSpinner;

export const ErrorMessage = TableErrorMessage;

export const VirtualizedRowsContainer = styled.div({
    position: 'relative',
    width: '100%',
});

export const VirtualItem = styled.div({
    left: 0,
    position: 'absolute',
    top: 0,
    width: '100%',
});
